import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CampaModalId } from 'src/app/pages/campas/campas.component';
import * as uuid from "uuid";

export interface ActionDropdownOption {
  Id: CampaModalId;
  TranslateKey: string;
  Icon: string;
}

@Component({
  selector: 'app-action-dropdown-selector',
  templateUrl: './action-dropdown-selector.component.html',
  styleUrls: ['./action-dropdown-selector.component.scss']
})



export class ActionDropdownSelectorComponent {

  ContainerId = uuid.v4()

  @Input() IconUrl: string = "/assets/icons/lightning-bolt.svg"
  @Input() PlaceholderFilter: string = "Acciones"
  @Input() Options: ActionDropdownOption[] = []
  @Input() PopupWidth: string | undefined;

  @Output() filterValueEmitter = new EventEmitter<CampaModalId>()

  FilterOpen: boolean = false;

  openFilter() {
    this.FilterOpen = !this.FilterOpen;
  }

  emitFilterValue(option: ActionDropdownOption) {
    this.filterValueEmitter.emit(option.Id);
    this.FilterOpen = false;
  }


  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const absoluteElement = document.getElementById(this.ContainerId);

    if (
      this.FilterOpen &&
      absoluteElement &&
      !absoluteElement.contains(targetElement)
    ) {
      this.FilterOpen = false;
    }
  }


}


